
import Crud from '../views/CriticalityTypes/Crud'
import Entity from '../views/CriticalityTypes/Add'

const routes = {
    path: '/criticalitytypes',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/criticalitytypes/add',
            name: 'NewCriticalityTypes',
            component: Entity,
            meta: {
                pageTitle: 'Criticality types',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/criticalitytypes'
                    },
                    {
                        text: 'Add',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/criticalitytypes/edit/:id?',
            name: 'EditCriticalitytypes',
            component: Entity,
            meta: {
                pageTitle: 'Criticality types',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/criticalitytypes'
                    },
                    {
                        text: 'Edit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/criticalitytypes',
            name: 'list-criticalitytypes',
            component: Crud,
            meta: {
                pageTitle: 'Criticality types',
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
